<div class="uk-margin uk-search uk-search-default">
  <button class="uk-search-icon-flip disabled" type="submit" uk-search-icon></button>

  <input
    (input)="search($any($event.target).value)"
    class="uk-search-input"
    type="search"
    [placeholder]="placeholder"
    [value]="(state | async).params[searchFieldName]" />
</div>
